/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateSFTPRequest } from '../models/CreateSFTPRequest';
import type { CreateSFTPResponse } from '../models/CreateSFTPResponse';
import type { SFTPTestConnectionResponse } from '../models/SFTPTestConnectionResponse';
import type { TestSFTPConnectionRequest } from '../models/TestSFTPConnectionRequest';
import type { UpdateSFTPRequest } from '../models/UpdateSFTPRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SftpService {

    /**
     * Deletes an existing SFTP integration by ID.
     * @param orgId The ID of the OrgProfileIntegration to delete.
     * @returns any OK
     * @throws ApiError
     */
    public static deleteSftp(
        orgId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/integrations/sftp/delete/{orgId}',
            path: {
                'orgId': orgId,
            },
        });
    }

    /**
     * Retrieves an existing SFTP integration for a specific organization.
     * @param orgId The ID of the organization for which to retrieve the integration.
     * @param id The ID of the integration to retrieve.
     * @returns any OK
     * @throws ApiError
     */
    public static getSftpById(
        orgId: string,
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/integrations/sftp/{orgId}/{id}',
            path: {
                'orgId': orgId,
                'id': id,
            },
        });
    }

    /**
     * Updates an existing SFTP integration.
     * @param requestBody The update request.
     * @returns any OK
     * @throws ApiError
     */
    public static updateSftp(
        requestBody?: UpdateSFTPRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/integrations/sftp/update',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Creates a new SFTP integration.
     * @param requestBody
     * @returns CreateSFTPResponse OK
     * @throws ApiError
     */
    public static createSftp(
        requestBody?: CreateSFTPRequest,
    ): CancelablePromise<CreateSFTPResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/integrations/sftp/createSFTP',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Tests the SFTP connection.
     * @param requestBody
     * @returns SFTPTestConnectionResponse OK
     * @throws ApiError
     */
    public static testSftpConnection(
        requestBody?: TestSFTPConnectionRequest,
    ): CancelablePromise<SFTPTestConnectionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/integrations/sftp/testConnection',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

}
